import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-payment-cancel',
  imports: [CommonModule],
  template: `
    <div class="page-container">
      <div class="cancel-card">
        <div class="cancel-icon">⚠️</div>
        <h1>Zahlung abgebrochen</h1>
        <p>Sie haben die Zahlung abgebrochen. Ihr Abonnement wurde nicht aktiviert.</p>
        <div class="button-group">
          <button class="btn-secondary" (click)="navigateToHome()">
            Zurück zur Startseite
          </button>
          <button class="btn-primary" (click)="tryAgain()">
            Erneut versuchen
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .page-container {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 100vh;
      background-color: #f8fafc;
      padding: 20px;
    }

    .cancel-card {
      background-color: white;
      border-radius: 12px;
      padding: 48px;
      max-width: 500px;
      width: 100%;
      text-align: center;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    .cancel-icon {
      font-size: 4rem;
      margin-bottom: 24px;
    }

    h1 {
      font-size: 2rem;
      font-weight: 700;
      color: #1e293b;
      margin-bottom: 16px;
    }

    p {
      color: #64748b;
      font-size: 1.125rem;
      margin-bottom: 32px;
    }

    .button-group {
      display: flex;
      gap: 12px;
      justify-content: center;
    }

    .btn-primary, .btn-secondary {
      padding: 12px 24px;
      font-size: 1rem;
      font-weight: 600;
      border-radius: 8px;
      border: none;
      cursor: pointer;
      transition: all 0.2s ease;
    }

    .btn-primary {
      background-color: #667eea;
      color: white;
    }

    .btn-primary:hover {
      background-color: #5a67d8;
      transform: translateY(-2px);
    }

    .btn-secondary {
      background-color: #f1f5f9;
      color: #475569;
    }

    .btn-secondary:hover {
      background-color: #e2e8f0;
    }

    @media (max-width: 640px) {
      .button-group {
        flex-direction: column;
      }

      .btn-primary, .btn-secondary {
        width: 100%;
      }
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentCancelComponent {
  private router = inject(Router);

  navigateToHome() {
    this.router.navigate(['/']);
  }

  tryAgain() {
    // Return to landing page where they can try again
    this.router.navigate(['/'], { fragment: 'pricing' });
  }
}
